module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-conversa",
    class: {
      'shake-active': _vm.shakeChat, 'isFocus': _vm.isFocus
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "rementente"
  }, [_vm._v(_vm._s(_vm.destUser.nome))]), _vm._v(" "), _c('span', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "messages"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "conversa-loading"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.buildMensagens), function(m) {
    return _c('chat-conversa-mensagem', {
      key: m.id,
      attrs: {
        "mensagem": m,
        "currentUser": _vm.currentUser
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "send"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mensagem),
      expression: "mensagem"
    }],
    ref: "inputMessage",
    staticClass: "no-shortkey",
    attrs: {
      "placeholder": "Digite uma mensagem"
    },
    domProps: {
      "value": (_vm.mensagem)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enviaMensagem($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mensagem = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d78a9d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatConversa.vue
// module id = 1542
// module chunks = 17